import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../assets/css/carousel.css";
import AddSliderModal from "./AddSliderModal";
import CarouselItem from "./CarouselItem";
import { ReactComponent as LeftArrow } from "../assets/img/arrow_left.svg";
import { ReactComponent as RightArrow } from "../assets/img/arrow_right.svg";

const Carousel = ({ slides, isAdmin, refreshSliderGroups }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const uniqueId = Math.random().toString(36).substring(2, 9);
  const swiperRef = useRef(null); // 💥 store Swiper instance
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handleAddClick = () => {
    setModalIsOpen(true);
  };

  const sliderContent = slides.sliders && typeof slides.sliders === "object"
    ? Object.values(slides.sliders).map((slide, index) => (
        <SwiperSlide key={index}>
          <CarouselItem
            slide={slide}
            slides={slides}
            isAdmin={isAdmin}
            refreshSliderGroups={refreshSliderGroups}
          />
        </SwiperSlide>
      ))
    : null;

  // 💥 When swiper moves, update arrow states
  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const numberOfSlides = Object.keys(slides.sliders).length;

  return (
    <div className="carousel-container">
      <AddSliderModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        sliderId={slides.id}
        reloadData={refreshSliderGroups}
      />

      <Swiper
        autoHeight={true}
        modules={[Navigation, Pagination]}
        slidesPerView={1}
        spaceBetween={30}
        navigation={{
          nextEl: `.custom-next-${uniqueId}`,
          prevEl: `.custom-prev-${uniqueId}`,
        }}
        pagination={{
          el: `.custom-pagination-${uniqueId}`,
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="custom-dot ${className}"></span>`;
          },
        }}
        speed={500}
        autoplay={false}
        loop={false}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
      >
        {sliderContent}
        {isAdmin && (
          <SwiperSlide>
            <div className="slide-content">
              <div className="admin-plus-button" onClick={handleAddClick}>
                <button>+</button>
              </div>
            </div>
          </SwiperSlide>
        )}
      </Swiper>

      {/* Custom Arrows and Dots */}
      <div className="carousel-controls">
        <div className={`custom-pagination custom-pagination-${uniqueId}`}></div>

        {numberOfSlides > 1 && ( // 💥 Only show arrows if more than 1 slide
          <div className="carousel-arrows">
            <div className={`custom-arrow custom-prev-${uniqueId} ${isBeginning ? 'disabled' : ''}`}>
              <LeftArrow />
            </div>
            <div className={`custom-arrow custom-next-${uniqueId} ${isEnd ? 'disabled' : ''}`}>
              <RightArrow />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Carousel;
